import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import store from './reducers';

import { home_path } from './services/config';

import {
  PrivateRoute,
  // Header,
  MenuDrawer
} from './components';
import {
  Login,
  Dashboard,
  Glossary,
  Templates,
  Instructions,
  Calculation,
  ExtraInformationSources
} from './views';

import {CALCULATION_URL} from './views/innerURLs';

import Root from './Root';

// CSS
import './fontello/css/animation.css';
import './fontello/css/fontello.css';
import './index.css';




const App = () => (
  <Root store={store}>
    <BrowserRouter>
      <MenuDrawer />
      <div id="content-main">
        {/* <Header /> */}
        <Switch>
          <Route path="/" exact component={Login} />
          <PrivateRoute path={home_path} component={Dashboard} />
          <PrivateRoute path="/glossary" component={Glossary} />
          <PrivateRoute path="/templates" component={Templates} />
          <PrivateRoute path="/instructions" component={Instructions} />
          <PrivateRoute path="/extra-information" component={ExtraInformationSources} />
          <PrivateRoute path={CALCULATION_URL+'/:id?'} component={Calculation} />
        </Switch>
      </div>
    </BrowserRouter>
  </Root>
)


ReactDOM.render(<App />, document.getElementById('root'));
